import $ from 'jquery';
import '../vendor/bower-asset/datatables.net/js/jquery.dataTables.js';
import 'datatables.net-bs4/js/dataTables.bootstrap4.js';
import * as moment from 'moment'
import '../vendor/switchsys/zf-time/assets/js/time.js';

import 'bootstrap';

import 'select2';

import 'devbridge-autocomplete';

import 'summernote/dist/summernote-lite.js';

require('moment/locale/en-gb');
moment.locale('en_GB');